import { defineStore } from 'pinia'

export const useTourStore = defineStore('concerts', {
  state: () => ({
    datak: []
  }),
  getters: {
    tourDatak: (state) => state.datak
  },
  actions: {
    setTourDatak(data) {
      this.datak = data
    },
     updateTourData(data) {
      this.datak[this.datak.findIndex(e => e.id === data.id)] = { ...data }
    },
    addTourData(item){
       const date = new Date(item.data);
      // Encontramos la posición correcta
      const index = this.datak.findIndex(e => new Date(e.data) > date);
      if (index === -1) {
        // Si no hay fecha mayor, lo añadimos al final
        this.datak.push(item);
      } else {
        // Insertamos en la posición encontrada
        this.datak.splice(index, 0, item);
      }
    },
    deleteTourData(id){
      this.datak.splice(this.datak.findIndex(e => e.id === id), 1)
    }
  }
})
